import styled from 'styled-components';

type ContainerProps = {
  isEditing: boolean;
  hideEditButton: boolean;
  isDisabled?: boolean;
};

export const Footer = styled.div`
  display: flex;
  margin-top: 15px;
  gap: 16px;
`;

export const Container = styled.div<ContainerProps>`
  .editor-area {
    position: relative;
  }
  .w-md-editor * {
    font-family: 'arial';
    font-size: 15px;
    line-height: 1.5;
  }
  .w-md-editor-text {
    padding: 10px 20px;
  }
  .wmde-markdown {
    font-size: 15px;
  }
  .ql-toolbar {
    border-color: ${(prop) => prop.theme.colors['neutral-40']};
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
  .ql-container {
    border-color: ${(prop) => prop.theme.colors['neutral-40']};
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  .ql-editor li::before {
    text-align: left;
    margin-right: 0;
  }

  ${({ isDisabled }) =>
    isDisabled &&
    `
    pre div {
      opacity: 0.6;
      background: #ebebeb;
      pointer-events: none;
    }
  `}
`;

export const EditorContent = styled.div`
  padding: 0;
`;
